import * as z from "zod/v4";

export enum AcquisitionReferralStatusEnum {
	NewReferral = "New Referral",
	Prospecting = "Prospecting",
	PreviouslySubmitted = "Previously Submitted",
	UnderContract = "Under Contract",
	Closed = "Closed",
	NotPursuing = "Not Pursuing",
	SellerDeclined = "Seller Declined"
}

export const REFERRAL_ADDRESS_NOT_SELECTED = "Choose the address from the suggestions.";

export const REFERRAL_PHOTO_MAX_BYTES = 10 * 1024 * 1024;

export const stagedReferralPhotoSchema = z.object({
	providerKey: z.string().min(1),
	allocationToken: z.string().min(1).max(4096),
	displayName: z.string().min(1)
});

export type StagedReferralPhoto = z.infer<typeof stagedReferralPhotoSchema>;

export const referralPhotoUploadRequestSchema = z.object({
	referralId: z.uuidv4(),
	fileName: z.string().min(1).max(255),
	contentType: z
		.string()
		.trim()
		.regex(/^image\/[A-Za-z0-9.+-]+$/, "Referral photos must be images"),
	contentLength: z.number().int().positive().max(REFERRAL_PHOTO_MAX_BYTES)
});

export type ReferralPhotoUploadRequest = z.infer<typeof referralPhotoUploadRequestSchema>;

export const referrerEmailSchema = z
	.string()
	.refine((value) => z.email().safeParse(value.replace(/^ +| +$/g, "")).success, {
		message: "Please enter a valid email address"
	});
